import { type MouseEvent, type ReactNode, useCallback } from 'react';

export const useColumnWithMoreActionsCustomTrigger = <T,>() =>
  useCallback(
    ({ trigger }: { trigger: (props: { record: T }) => ReactNode }) => ({
      onCell: () => ({
        onClick(event: MouseEvent<HTMLElement>) {
          event.stopPropagation();
        },
      }),
      render(_: unknown, record: T) {
        return <>{trigger({ record })}</>;
      },
      width: 48,
    }),
    [],
  );
